export function getFileSize(size: number | string): number {
	return parseFloat((parseFloat(size.toString()) / (1024 * 1024)).toFixed(3));
}
